'use client';
import React from 'react';
import { Button, Text } from '@benzinga/core-ui';
import { SmartLink } from '@benzinga/analytics';
import Image from 'next/image';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import type { ProductBasedCTAProps, ProductBasedCTALayout } from './ProductBasedCTA';
import { withYmailParam } from './withYmailParam';
import styles from './CompactAdCards.module.scss';

export interface CompactAdCardsProps {
  groups?: ProductBasedCTAProps[];
  layout?: ProductBasedCTALayout;
  location?: string;
}

export const CompactAdCards: React.FC<CompactAdCardsProps> = ({ groups = [], layout, location = 'default' }) => (
  <div className={`p-1 ${layout ?? ''}`}>
    {groups.map(campaign => {
      if (!campaign?.url) return null;
      const href = withYmailParam(campaign.url);

      return (
        <div className={`${styles.callToActionContainer} flex flex-col gap-1 items-center`} key={campaign.url}>
          <div className="promo-image-wrap flex items-center justify-center m-auto sm:m-0">
            {campaign?.image_url ? (
              <div className={`${styles.imageWrapper} min-w-[120px]`}>
                <Image
                  alt={campaign.title}
                  className="h-[75px] max-w-full object-contain"
                  height={75}
                  sizes="120px"
                  src={campaign.image_url}
                  width={120}
                />
              </div>
            ) : null}
          </div>
          <div className="flex call-to-action-copy center">
            <div>
              <div className={`${styles.title} text-black`}>{campaign.title}</div>
              {campaign.description ? (
                <Text
                  className={`${styles.CTADescription} text-gray-600`}
                  dangerouslySetInnerHTML={{ __html: sanitizeHTML(campaign.description) }}
                  lines={2}
                />
              ) : null}
              {!campaign?.disable_disclosure && campaign?.review_url && (
                <small className={`flex flex-row pb-0 text-gray-400 justify-center`}>
                  {campaign?.review && <span className="pr-1">{campaign?.review}</span>}
                  {campaign?.review_url && (
                    <a
                      className={`${styles.disclosureLink} disclosure-link text-gray-400 underline`}
                      href={campaign?.review_url}
                      target="_blank"
                    >
                      (17b disclosure)
                    </a>
                  )}
                </small>
              )}
            </div>
          </div>
          <div className="min-w-full sm:min-w-[130px] ml-auto m-auto sm:m-0">
            <SmartLink action="click" category={location} href={href} key={campaign.url}>
              <Button className="w-full uppercase" variant="flat-blue">
                {campaign.button_text ? campaign.button_text : 'Get Started'}
              </Button>
            </SmartLink>
          </div>
        </div>
      );
    })}
  </div>
);
